import { const_var, params } from "../../../redux/reducers/reducer";
import { convertToTwoDecimalNumber, getPercentPrice, num } from "../../../redux/reducers/utils";
import { calcWainscotPrice } from "../../building/building_color/wainscotColor.helper";
import { calcWallCostUtility } from "../utility_pricing/utilityPricingHelper";
import { calcWallCost } from "../wall_pricing/wallPricing.helper";

export function roofColorPricingCalculation(roofCostConfig, post_data, leantoRoofColorPrice, leantoSquareFeetPrice) {
	let finalPrice = 0;
	if (roofCostConfig) {
		const isManualOverride = const_var.UpdatedPriceData.roof_color_price_changed !== true;
		let finalColorCost = const_var.UpdatedPriceData.roof_color_price;
		if (!isManualOverride) {
			const roofStylePrice = num(post_data["building"].roof_style_price);
			const buildingArea = num(post_data["building"].width) * num(post_data["building"].length);
			const cost = num(roofCostConfig.cost);
			switch (roofCostConfig.cost_type.toLowerCase()) {
				case "per":
				case "%":
				case "PERCENTAGE".toLowerCase():
					finalColorCost = ((num(leantoRoofColorPrice) + roofStylePrice) * cost) / 100;
					break;
				case "sqft":
					finalColorCost = (num(leantoSquareFeetPrice) + buildingArea) * cost;
					break;
				case "ft":
					finalColorCost = num(leantoRoofColorPrice) + roofStylePrice + cost;
					break;
				case "$":
					finalColorCost = num(cost);
					break;
			}
		}
		post_data["building"].roof_color_price = num(finalColorCost);
		finalPrice = num(post_data["building"].roof_color_price);
		post_data["building"].roof_color.roof_color_price = post_data["building"].roof_color_price;
		return finalPrice;
	}
	return finalPrice;
}

export function wallColorPricingCalculation(wallCostConfig, post_data, leantoWallColorPrice, leantoSquareFeetPrice) {
	let finalPrice = 0;
	if (wallCostConfig) {
		const isManualOverride = const_var.UpdatedPriceData.wall_color_price_changed !== true;
		let finalColorCost = const_var.UpdatedPriceData.wall_color_price;
		if (!isManualOverride) {
			let wallPriceCal = 0;
			if (post_data["building"].utility_price && params.p_u_c === true) {
				wallPriceCal = num(post_data["building"].front_wall_price) + num(post_data["building"].left_wall_price) + num(post_data["building"].right_wall_price) + num(post_data["building"].utility_price);
			} else {
				wallPriceCal = num(post_data["building"].front_wall_price) + num(post_data["building"].back_wall_price) + num(post_data["building"].left_wall_price) + num(post_data["building"].right_wall_price);
			}
			if (post_data["building"].utility_front_price && params.isBreezeway && params.cB_addStorage_check_front) {
				wallPriceCal += num(post_data["building"].utility_front_price || 0);
			}
			const buildingArea = num(post_data["building"].width) * num(post_data["building"].length);
			const cost = num(wallCostConfig.cost) || 0;
			switch (wallCostConfig.cost_type.toLowerCase()) {
				case "%":
				case "per":
				case "PERCENTAGE".toLowerCase():
					const base = leantoWallColorPrice + wallPriceCal;
					finalColorCost = getPercentPrice({ price: cost, post_data, customBase: base });
					break;
				case "sqft":
					finalColorCost = (num(leantoSquareFeetPrice) + buildingArea) * cost;
					break;
				case "ft":
					finalColorCost = num(leantoWallColorPrice) + wallPriceCal + cost;
				case "$":
					finalColorCost = num(cost);
					break;
			}
		}
		post_data["building"].wall_color_price = num(finalColorCost);
		finalPrice = parseFloat(post_data["building"].wall_color_price);
		if (post_data["building"].wall_color) {
			post_data["building"].wall_color.wall_color_price = post_data["building"].wall_color_price;
		}
		return finalPrice;
	}
	return finalPrice;
}
export const calcRoofColorPrice = (width, length, costObj, paramsData, islean, wrapIncludedCount) => {
	let Price = 0;
	let roofWidth = params.m_s_n == 93 ? parseInt(width) + 2 : parseInt(width) + 1;
	let rooflength = params.m_s_n == 93 ? parseInt(length) + 1 : parseInt(length);

	let overhangSideWidth = 0;
	let overhangEndWidth = 0;

	if (paramsData.o_v_h_n_g == true) {
		// true if side overhang is checked
		overhangSideWidth = const_var.isOverhang["side"]["size"];
	}
	if (paramsData.o_v_h_n_g_e == true) {
		// true if end overhang is checked
		overhangEndWidth = const_var.isOverhang["end"]["size"];
	}

	if (islean == true) {
		roofWidth = parseFloat(roofWidth) + parseFloat(overhangSideWidth);
	} else {
		roofWidth = parseFloat(roofWidth) + parseFloat(overhangSideWidth) * 2;
	}

	if (islean == true && wrapIncludedCount != undefined && wrapIncludedCount == 1) {
		rooflength = parseFloat(rooflength) + parseFloat(overhangEndWidth);
	} else {
		if (wrapIncludedCount != 2) {
			rooflength = parseFloat(rooflength) + parseFloat(overhangEndWidth) * 2;
		}
	}

	Price = parseFloat(roofWidth) * parseFloat(rooflength) * parseFloat(costObj.cost);
	return Price;
};
export function trimColorPricingCalculation(trimCostConfig, post_data, leantoTrimColorPrice, leantoRoofColorPrice, leantoSquareFeetPrice) {
	let finalPrice = 0;
	if (params.m_s_n == 58) {
		post_data["building"].trim_color_price = const_var.UpdatedPriceData.trim_color_price_changed != true ? const_var.UpdatedPriceData.trim_color_price : 0;
		post_data["building"].trim_color.trim_color_price = post_data["building"].trim_color_price;
		return finalPrice;
	}
	if (trimCostConfig) {
		const isManualOverride = const_var.UpdatedPriceData.trim_color_price_changed !== true;
		let finalColorCost = const_var.UpdatedPriceData.trim_color_price;
		if (!isManualOverride) {
			const leantrimPrice = num(leantoTrimColorPrice) + num(leantoRoofColorPrice);
			const roofStylePrice = num(post_data["building"].roof_style_price);
			const heightPrice = num(post_data["building"].height_price);
			const buildingArea = num(post_data["building"].width) * num(post_data["building"].length);
			const cost = num(trimCostConfig.cost);
			switch (trimCostConfig.cost_type.toLowerCase()) {
				case "per":
				case "%":
				case "PERCENTAGE".toLowerCase():
					const base = roofStylePrice + heightPrice + leantrimPrice;
					finalColorCost = getPercentPrice({ price: cost, post_data, customBase: base });

					break;
				case "sqft":
					finalColorCost = (num(leantoSquareFeetPrice) + buildingArea) * cost;
					break;
				case "ft":
					finalColorCost = roofStylePrice + heightPrice + leantrimPrice + cost;
					break;
				case "$":
					finalColorCost = num(cost);
					break;
			}
		}
		post_data["building"].trim_color_price = num(finalColorCost);
		finalPrice = num(post_data["building"].trim_color_price);
		post_data["building"].trim_color.trim_color_price = post_data["building"].trim_color_price;
		return finalPrice;
	}
	return finalPrice;
}

export function wainscotColorPricingCalculation(wainscotCostConfig, post_data, leantoSquareFeetPrice, data) {
	let finalPrice = 0;
	if (!params.p_w_c_n) {
		return finalPrice;
	}
	if (wainscotCostConfig) {
		const isManualOverride = const_var.UpdatedPriceData.wainscot_price_changed !== true;
		let finalColorCost = const_var.UpdatedPriceData.wainscot_color_price;
		if (!isManualOverride) {
			const wainscotPrice = num(post_data["building"].wainscot_price);
			const buildingArea = num(post_data["building"].width) * num(post_data["building"].length);
			const fullyEnclosedWalls = const_var.cbFullyEnclosedWalls + const_var.flFullyEnclosedWalls + const_var.llFullyEnclosedWalls + const_var.rlFullyEnclosedWalls + const_var.blFullyEnclosedWalls;
			const basePanelCost = num(data?.panel?.[0]?.cost) * fullyEnclosedWalls;
			const cost = num(wainscotCostConfig.cost);
			switch (wainscotCostConfig.cost_type.toLowerCase()) {
				case "%":
				case "per":
				case "PERCENTAGE".toLowerCase():
					const base = wainscotPrice || basePanelCost;
					finalColorCost = getPercentPrice({ price: cost, post_data, customBase: base });

					break;
				case "sqft":
					finalColorCost = (num(leantoSquareFeetPrice) + buildingArea) * cost;
					break;
				case "$":
					finalColorCost = num(cost);
					break;
			}
		}

		post_data["building"].wainscot_color_price = num(finalColorCost);
		finalPrice = num(post_data["building"].wainscot_color_price);
		post_data["building"].wainscot.wainscot_color_price = post_data["building"].wainscot_color_price;
		return finalPrice;
	}
	return finalPrice;
}
export function calcColorPriceWithCostType(costObj, leantoPriceCalculation, totalPriceWithoutAdditionalItem, calcfor, paramsData, buildingData, totalCost, pricingData = undefined) {
	let finalCost = 0;

	if (const_var.checkmoreCustomizeFlag == false || parseFloat(totalPriceWithoutAdditionalItem) != 0) {
		if (const_var.colorPrice.roof_color_price_changed == false && calcfor == "roof") {
			const_var.UpdatedPriceData.roof_color_price_changed = true;
		}
		if (const_var.colorPrice.wall_color_price_changed == false && calcfor == "wall") {
			const_var.UpdatedPriceData.wall_color_price_changed = true;
		}
		if (const_var.colorPrice.trim_color_price_changed == false && calcfor == "trim") {
			const_var.UpdatedPriceData.trim_color_price_changed = true;
		}
		if (const_var.colorPrice.wainscot_color_price_changed == false && calcfor == "wainscot") {
			const_var.UpdatedPriceData.wainscot_price_changed = true;
		}

		if (costObj != undefined) {
			if (costObj.cost_type == "%" || costObj.cost_type == "1") {
				var splitVal = costObj.price_of != undefined && costObj.price_of.length > 0 ? costObj.price_of : 0;
				var splval = 0;
				if (splitVal != 0) {
					if (splitVal.includes("full_building_price") != false) {
						splval = parseFloat(splval) + parseFloat(totalCost);
					}
					if (splitVal.includes("base_price") != false) {
						splval = parseFloat(splval) + parseFloat(buildingData.roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice);
					}
					if (splitVal.includes("wall_price") != false) {
						if (calcfor == "wainscot") {
							let allPricingData = const_var.isLTBuilding ? JSON.parse(JSON.stringify(const_var.holdPricingResponse)) : pricingData != undefined ? pricingData : const_var.a_p_d_a;
							let cbPanelPrice = 0;
							let cbGabelPrice = 0;
							let leanToWall = 0;

							let centerBuildingWall = 0;
							let leftleanPanelPrice = 0;
							let rightleanPanelPrice = 0;
							let backleanPanelPrice = 0;
							let frontleanPanelPrice = 0;
							let leftleanGabelPrice = 0;
							let rightleanGabelPrice = 0;
							let backleanGabelPrice = 0;
							let frontleanGabelPrice = 0;
							if (Object.keys(const_var.wallsData["center"]).length > 0) {
								cbPanelPrice = parseFloat((allPricingData.full_length_panel && allPricingData.full_length_panel[0].cost) || 0);
								cbGabelPrice = parseFloat((allPricingData.gable_end && allPricingData.gable_end[0]?.certified) || 0);
								if (params.p_v_w) {
									cbPanelPrice = parseFloat((allPricingData.full_length_panel && allPricingData.full_length_panel[0].vertical_panel_cost) || 0);
									cbGabelPrice = parseFloat(cbGabelPrice) + parseFloat((allPricingData.gable_end && allPricingData.gable_end[0].vertical_certified) || 0);
								}
							}

							if (Object.keys(const_var.wallsData["frontLean"]).length > 0 && paramsData.add_front_lean == true) {
								frontleanPanelPrice = (const_var.leanGetDataFront && const_var.leanGetDataFront.full_length_panel[0].cost) || 0;
								frontleanGabelPrice = parseFloat((const_var.leanGetDataFront && const_var.leanGetDataFront.gable_end && const_var.leanGetDataFront.gable_end[0]?.certified) || 0);

								if (params.p_v_w) {
									frontleanPanelPrice = (const_var.leanGetDataFront && const_var.leanGetDataFront.full_length_panel[0].vertical_panel_cost) || 0;
									frontleanGabelPrice =
										parseFloat(frontleanGabelPrice) +
										parseFloat((const_var.leanGetDataFront && const_var.leanGetDataFront.gable_end && const_var.leanGetDataFront.gable_end[0].vertical_certified) || 0);
								}

								leanToWall =
									parseFloat(leanToWall) +
									(const_var.wallsData["frontLean"].p_b_c_b_f_l == "Close" ? parseFloat(frontleanPanelPrice) : 0) +
									(params.leanStyle.front == "gable" && const_var.wallsData["frontLean"].p_b_c_b_f_r == "Close" ? parseFloat(frontleanPanelPrice) : 0) +
									(const_var.wallsData["frontLean"].p_b_c_b_f_f == "Close" ? parseFloat(frontleanGabelPrice) : 0) +
									(const_var.wallsData["frontLean"].p_b_c_b_f_b == "Close" ? parseFloat(frontleanGabelPrice) : 0);

								if (paramsData.add_storage_check_front == true) {
									let utilityPanelPrice = params.p_v_w
										? (const_var.leanGetDataFront && const_var.leanGetDataFront.panel[0].vertical_panel_cost) || 0
										: (const_var.leanGetDataFront && const_var.leanGetDataFront.panel[0].cost) || 0;
									leanToWall =
										parseFloat(leanToWall) +
										parseFloat(frontleanGabelPrice) +
										parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_l == "Close" ? 0 : utilityPanelPrice) +
										(params.leanStyle.front == "gable" ? parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_r == "Close" ? 0 : utilityPanelPrice) : 0) +
										parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_b == "Close" ? 0 : frontleanGabelPrice) +
										(const_var.wallsData["center"].p_f_w == "Close" ? 0 : utilityPanelPrice);
								}
							}
							if (Object.keys(const_var.wallsData["backLean"]).length > 0 && paramsData.add_back_lean == true) {
								backleanPanelPrice = (const_var.leanGetDataBack && const_var.leanGetDataBack.full_length_panel[0].cost) || 0;
								backleanGabelPrice = parseFloat((const_var.leanGetDataBack && const_var.leanGetDataBack.gable_end && const_var.leanGetDataBack.gable_end[0]?.certified) || 0);

								if (params.p_v_w) {
									backleanPanelPrice = (const_var.leanGetDataBack && const_var.leanGetDataBack.full_length_panel[0].vertical_panel_cost) || 0;
									backleanGabelPrice =
										parseFloat(backleanGabelPrice) + parseFloat((const_var.leanGetDataBack && const_var.leanGetDataBack.gable_end && const_var.leanGetDataBack.gable_end[0].vertical_certified) || 0);
								}

								leanToWall =
									parseFloat(leanToWall) +
									(const_var.wallsData["backLean"].p_b_c_b_b_l == "Close" ? parseFloat(backleanGabelPrice) : 0) +
									(params.leanStyle.back == "gable" && const_var.wallsData["backLean"].p_b_c_b_b_r == "Close" ? parseFloat(backleanGabelPrice) : 0) +
									(const_var.wallsData["backLean"].p_b_c_b_b_f == "Close" ? parseFloat(backleanGabelPrice) : 0) +
									(const_var.wallsData["backLean"].p_b_c_b_b_b == "Close" ? parseFloat(backleanPanelPrice) : 0);
								if (paramsData.add_storage_check_back == true) {
									let utilityPanelPrice = params.p_v_w
										? (const_var.leanGetDataBack && const_var.leanGetDataBack.panel[0].vertical_panel_cost) || 0
										: (const_var.leanGetDataBack && const_var.leanGetDataBack.panel[0].cost) || 0;
									leanToWall =
										parseFloat(leanToWall) +
										parseFloat(backleanGabelPrice) +
										(const_var.wallsData["backLean"].p_b_c_b_b_l == "Close" ? 0 : utilityPanelPrice) +
										(params.leanStyle.back == "gable" ? (const_var.wallsData["backLean"].p_b_c_b_b_r == "Close" ? 0 : utilityPanelPrice) : 0) +
										(const_var.wallsData["backLean"].p_b_c_b_b_b == "Close" ? 0 : backleanGabelPrice) +
										(const_var.wallsData["center"].p_b_w == "Close" ? 0 : utilityPanelPrice);
								}
							}
							if (Object.keys(const_var.wallsData["leftLean"]).length > 0 && paramsData.add_left_lean == true) {
								leftleanPanelPrice = (const_var.leanGetDataLeft && const_var.leanGetDataLeft.full_length_panel[0].cost) || 0;
								leftleanGabelPrice = parseFloat((const_var.leanGetDataLeft && const_var.leanGetDataLeft.gable_end && const_var.leanGetDataLeft.gable_end[0]?.certified) || 0);

								if (params.p_v_w) {
									leftleanPanelPrice = parseFloat((const_var.leanGetDataLeft && const_var.leanGetDataLeft.full_length_panel[0].vertical_panel_cost) || 0);
									leftleanGabelPrice =
										parseFloat(leftleanGabelPrice) + parseFloat((const_var.leanGetDataLeft && const_var.leanGetDataLeft.gable_end && const_var.leanGetDataLeft.gable_end[0].vertical_certified) || 0);
								}

								leanToWall =
									parseFloat(leanToWall) +
									(const_var.wallsData["leftLean"].p_b_c_b_l_f == "Close" ? parseFloat(leftleanGabelPrice) : 0) +
									(const_var.wallsData["leftLean"].p_b_c_b_l_b == "Close" ? parseFloat(leftleanGabelPrice) : 0) +
									(const_var.wallsData["leftLean"].p_b_c_b_l == "Close" ? parseFloat(leftleanPanelPrice) : 0) +
									(params.leanStyle.left == "gable" && const_var.wallsData["leftLean"].p_b_c_b_l_r == "Close" ? parseFloat(leftleanPanelPrice) : 0);
								if (paramsData.add_storage_check == true) {
									let utilityPanelPrice = params.p_v_w
										? (const_var.leanGetDataLeft && const_var.leanGetDataLeft.panel[0].vertical_panel_cost) || 0
										: (const_var.leanGetDataLeft && const_var.leanGetDataLeft.panel[0].cost) || 0;
									leanToWall =
										parseFloat(leanToWall) +
										parseFloat(leftleanGabelPrice) +
										(const_var.wallsData["leftLean"].p_b_c_b_l == "Close" ? 0 : utilityPanelPrice) +
										(params.leanStyle.left == "gable" ? (const_var.wallsData["leftLean"].p_b_c_b_l_r == "Close" ? 0 : utilityPanelPrice) : 0) +
										(const_var.wallsData["leftLean"].p_b_c_b_l_b == "Close" ? 0 : parseFloat(leftleanGabelPrice)) +
										(const_var.wallsData["center"].p_l_w == "Close" ? 0 : utilityPanelPrice);
								}
							}
							if (Object.keys(const_var.wallsData["rightLean"]).length > 0 && paramsData.add_right_lean == true) {
								rightleanPanelPrice = (const_var.leanGetDataRight && const_var.leanGetDataRight.full_length_panel[0].cost) || 0;
								rightleanGabelPrice = parseFloat((const_var.leanGetDataRight && const_var.leanGetDataRight.gable_end && const_var.leanGetDataRight.gable_end[0]?.certified) || 0);

								if (params.p_v_w) {
									rightleanPanelPrice = parseFloat((const_var.leanGetDataRight && const_var.leanGetDataRight.full_length_panel[0].vertical_panel_cost) || 0);
									rightleanGabelPrice =
										parseFloat(rightleanGabelPrice) +
										parseFloat((const_var.leanGetDataRight && const_var.leanGetDataRight.gable_end && const_var.leanGetDataRight.gable_end[0].vertical_certified) || 0);
								}

								leanToWall =
									parseFloat(leanToWall) +
									(const_var.wallsData["rightLean"].p_b_c_b_r == "Close" ? parseFloat(rightleanPanelPrice) : 0) +
									(params.leanStyle.right == "gable" && const_var.wallsData["rightLean"].p_b_c_b_r_r == "Close" ? parseFloat(rightleanPanelPrice) : 0) +
									(const_var.wallsData["rightLean"].p_b_c_b_r_b == "Close" ? parseFloat(rightleanGabelPrice) : 0) +
									(const_var.wallsData["rightLean"].p_b_c_b_r_f == "Close" ? parseFloat(rightleanGabelPrice) : 0);
								if (paramsData.add_storage_check_right == true) {
									let utilityPanelPrice = params.p_v_w
										? (const_var.leanGetDataRight && const_var.leanGetDataRight.panel[0].vertical_panel_cost) || 0
										: (const_var.leanGetDataRight && const_var.leanGetDataRight.panel[0].cost) || 0;
									leanToWall =
										parseFloat(leanToWall) +
										parseFloat(rightleanGabelPrice) +
										(const_var.wallsData["rightLean"].p_b_c_b_r == "Close" ? 0 : parseFloat(utilityPanelPrice)) +
										(params.leanStyle.right == "gable" ? (const_var.wallsData["rightLean"].p_b_c_b_r_r == "Close" ? 0 : parseFloat(utilityPanelPrice)) : 0) +
										(const_var.wallsData["rightLean"].p_b_c_b_r_b == "Close" ? 0 : parseFloat(rightleanGabelPrice)) +
										(const_var.wallsData["center"].p_r_w == "Close" ? 0 : utilityPanelPrice);
								}
							}

							centerBuildingWall =
								(const_var.wallsData["center"].p_f_w == "Close" ? parseFloat(cbGabelPrice) : 0) +
								(const_var.wallsData["center"].p_b_w == "Close" ? parseFloat(cbGabelPrice) : 0) +
								(const_var.wallsData["center"].p_l_w == "Close" ? parseFloat(cbPanelPrice) : 0) +
								(const_var.wallsData["center"].p_r_w == "Close" ? parseFloat(cbPanelPrice) : 0);

							if (paramsData.p_u_c == true || paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
								let UtilityPrice = 0;
								let utilityPanelPrice = parseFloat((allPricingData.panel && allPricingData.panel[0].cost) || 0);
								let utilityGablePrice = cbGabelPrice;
								if (params.p_v_w) {
									utilityPanelPrice = parseFloat((allPricingData.panel && allPricingData.panel[0].vertical_panel_cost) || 0);
								}

								if (paramsData.p_u_c == true) {
									UtilityPrice =
										parseFloat(utilityGablePrice) +
										parseFloat(const_var.wallsData["center"].p_b_w == "Close" ? 0 : utilityGablePrice) +
										parseFloat(const_var.wallsData["center"].p_l_w == "Close" ? 0 : utilityPanelPrice) +
										parseFloat(const_var.wallsData["center"].p_r_w == "Close" ? 0 : utilityPanelPrice);
								}
								if (paramsData.cB_addStorage_check_left == true) {
									UtilityPrice =
										parseFloat(utilityPanelPrice) +
										parseFloat(const_var.wallsData["center"].p_f_w == "Close" ? 0 : utilityGablePrice) +
										parseFloat(const_var.wallsData["center"].p_b_w == "Close" ? 0 : utilityGablePrice) +
										parseFloat(const_var.wallsData["center"].p_l_w == "Close" ? 0 : utilityPanelPrice);
								}
								if (paramsData.cB_addStorage_check_right == true) {
									UtilityPrice =
										parseFloat(utilityPanelPrice) +
										parseFloat(const_var.wallsData["center"].p_f_w == "Close" ? 0 : utilityGablePrice) +
										parseFloat(const_var.wallsData["center"].p_b_w == "Close" ? 0 : utilityGablePrice) +
										parseFloat(const_var.wallsData["center"].p_r_w == "Close" ? 0 : utilityPanelPrice);
								}
								splval = parseFloat(splval) + parseFloat(UtilityPrice) + parseFloat(centerBuildingWall) + parseFloat(leanToWall);
							} else {
								splval = parseFloat(splval) + parseFloat(centerBuildingWall) + parseFloat(leanToWall);
							}
						} else {
							if (paramsData.p_u_c == true || paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
								splval =
									parseFloat(splval) +
									parseFloat(buildingData.utility_price) +
									parseFloat(buildingData.front_wall_price) +
									parseFloat(buildingData.left_wall_price) +
									parseFloat(buildingData.right_wall_price) +
									parseFloat(buildingData.back_wall_price) +
									parseFloat(leantoPriceCalculation.totalWallPrice);
							} else {
								splval =
									parseFloat(splval) +
									parseFloat(buildingData.front_wall_price) +
									parseFloat(buildingData.left_wall_price) +
									parseFloat(buildingData.right_wall_price) +
									parseFloat(buildingData.back_wall_price) +
									parseFloat(leantoPriceCalculation.totalWallPrice);
							}
							if (buildingData.utility_front_price != undefined && paramsData.isBreezeway && paramsData.cB_addStorage_check_front) {
								splval = parseFloat(splval) + parseFloat(buildingData.utility_front_price);
							}
						}
					}
					if (splitVal.includes("height_price") != false) {
						splval = parseFloat(splval) + parseFloat(buildingData.height_price) + parseFloat(leantoPriceCalculation.totalHeightPrice);
					}
				} else {
					splval = parseFloat(splval) + parseFloat(totalPriceWithoutAdditionalItem);
				}
				finalCost = (splval * costObj.cost) / 100;
			} else if (costObj.cost_type == "sqft" || costObj.cost_type == "2") {
				let roofPrice = 0;
				let sidePrice = 0;
				let endPrice = 0;
				let endCount = 0;
				let sideCount = 0;
				let wainscotPrice = 0;

				if (calcfor == "trim") {
					let widthCalc = 0;
					let heightCalc = 0;
					let lengthCalc = 0;
					if (Object.keys(const_var.wallsData["center"]).length > 0) {
						if (
							const_var.wallsData["center"].p_b_w == "Open" &&
							const_var.wallsData["center"].p_f_w == "Open" &&
							const_var.wallsData["center"].p_l_w == "Open" &&
							const_var.wallsData["center"].p_r_w == "Open"
						) {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.p_d) * 2 * costObj.cost;
							if (paramsData.p_u_c == true || paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.p_h) * 4 * costObj.cost;
							}
						} else {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.p_d) * 2 * costObj.cost;

							if (
								const_var.wallsData["center"].p_b_w == "Close" &&
								const_var.wallsData["center"].p_f_w == "Close" &&
								const_var.wallsData["center"].p_l_w == "Close" &&
								const_var.wallsData["center"].p_r_w == "Close"
							) {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.p_h) * 4 * costObj.cost;
							} else {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.p_h) * 4 * costObj.cost;
								if (paramsData.p_u_c == true && const_var.wallsData["center"].p_f_w == "Close") {
									heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.p_h) * 2 * costObj.cost;
								}
								if (paramsData.cB_addStorage_check_left == true && const_var.wallsData["center"].p_r_w == "Close") {
									heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.p_h) * 2 * costObj.cost;
								}
								if (paramsData.cB_addStorage_check_right == true && const_var.wallsData["center"].p_l_w == "Close") {
									heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.p_h) * 2 * costObj.cost;
								}
							}
						}
					}
					if (Object.keys(const_var.wallsData["frontLean"]).length > 0 && paramsData.add_front_lean == true) {
						if (const_var.wallsData["frontLean"].p_b_c_b_f_b == "Open" && const_var.wallsData["frontLean"].p_b_c_b_f_f == "Open" && const_var.wallsData["frontLean"].p_b_c_b_f_l == "Open") {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.leanF_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.leanF_p_d) * costObj.cost;
							if (paramsData.add_storage_check_front == true) {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanF_p_h) * 2 * costObj.cost;
							}
						} else {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.leanF_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.leanF_p_d) * costObj.cost;
							heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanF_p_h) * 2 * costObj.cost;
							if (paramsData.add_storage_check_front == true && const_var.wallsData["frontLean"].p_b_c_b_f_f == "Close") {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanF_p_h) * costObj.cost;
							}
						}
					}
					if (Object.keys(const_var.wallsData["backLean"]).length > 0 && paramsData.add_back_lean == true) {
						if (const_var.wallsData["backLean"].p_b_c_b_b_b == "Open" && const_var.wallsData["backLean"].p_b_c_b_b_f == "Open" && const_var.wallsData["backLean"].p_b_c_b_b_l == "Open") {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.leanB_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.leanB_p_d) * costObj.cost;
							if (paramsData.add_storage_check_back == true) {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanB_p_h) * 2 * costObj.cost;
							}
						} else {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.leanB_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.leanB_p_d) * costObj.cost;
							heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanB_p_h) * 2 * costObj.cost;
							if (paramsData.add_storage_check_back == true && const_var.wallsData["backLean"].p_b_c_b_b_f == "Close") {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanB_p_h) * costObj.cost;
							}
						}
					}
					if (Object.keys(const_var.wallsData["leftLean"]).length > 0 && paramsData.add_left_lean == true) {
						if (const_var.wallsData["leftLean"].p_b_c_b_l_b == "Open" && const_var.wallsData["leftLean"].p_b_c_b_l_f == "Open" && const_var.wallsData["leftLean"].p_b_c_b_l == "Open") {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.lean_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.lean_p_d) * costObj.cost;
							if (paramsData.add_storage_check == true) {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.lean_p_h) * 2 * costObj.cost;
							}
						} else {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.lean_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.lean_p_d) * costObj.cost;
							heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.lean_p_h) * 2 * costObj.cost;
							if (paramsData.add_storage_check == true && const_var.wallsData["leftLean"].p_b_c_b_l_f == "Close") {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.lean_p_h) * costObj.cost;
							}
						}
					}
					if (Object.keys(const_var.wallsData["rightLean"]).length > 0 && paramsData.add_right_lean == true) {
						if (const_var.wallsData["rightLean"].p_b_c_b_r_b == "Open" && const_var.wallsData["rightLean"].p_b_c_b_r_f == "Open" && const_var.wallsData["rightLean"].p_b_c_b_r == "Open") {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.leanR_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.leanR_p_d) * costObj.cost;
							if (paramsData.add_storage_check_right == true) {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanR_p_h) * 2 * costObj.cost;
							}
						} else {
							widthCalc = parseFloat(widthCalc) + parseFloat(paramsData.leanR_p_w) * 2 * costObj.cost;
							lengthCalc = parseFloat(lengthCalc) + parseFloat(paramsData.leanR_p_d) * costObj.cost;
							heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanR_p_h) * 2 * costObj.cost;
							if (paramsData.add_storage_check_right == true && const_var.wallsData["rightLean"].p_b_c_b_r_f == "Close") {
								heightCalc = parseFloat(heightCalc) + parseFloat(paramsData.leanR_p_h) * costObj.cost;
							}
						}
					}
					let trimfinalCost = parseFloat(widthCalc) + parseFloat(lengthCalc) + parseFloat(heightCalc);
					if (const_var.isLNTBuildingIsCustom === true) {
						return 0;
					}
					return convertToTwoDecimalNumber(trimfinalCost);
				} else {
					if (Object.keys(const_var.wallsData["center"]).length > 0) {
						if (calcfor == "wainscot") {
							let fullClosedWidthCalc = 0;
							let fullClosedLengthCalc = 0;
							if (paramsData.p_u_c == true) {
								fullClosedLengthCalc =
									parseFloat(
										const_var.wallsData["center"].p_l_w == "Close"
											? paramsData.p_d
											: paramsData.add_storage_check && parseFloat(paramsData.add_storage) > parseFloat(paramsData.p_u_t)
												? 0
												: paramsData.p_u_t
									) +
									parseFloat(
										const_var.wallsData["center"].p_r_w == "Close"
											? paramsData.p_d
											: paramsData.add_storage_check_right == true && parseFloat(paramsData.add_storage_right) > parseFloat(paramsData.p_u_t)
												? 0
												: paramsData.p_u_t
									);
								fullClosedWidthCalc =
									parseFloat(const_var.wallsData["center"].p_f_w == "Close" ? paramsData.p_w : 0) + parseFloat(const_var.wallsData["center"].p_b_w == "Close" ? paramsData.p_w : 0) + paramsData.p_w;
							} else if (paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
								fullClosedLengthCalc =
									parseFloat(const_var.wallsData["center"].p_l_w == "Close" ? paramsData.p_d : 0) +
									parseFloat(const_var.wallsData["center"].p_r_w == "Close" ? paramsData.p_d : 0) +
									parseFloat(paramsData.p_d);

								if (paramsData.cB_addStorage_check_left == true) {
									fullClosedWidthCalc =
										parseFloat(
											const_var.wallsData["center"].p_f_w == "Close"
												? paramsData.p_w
												: paramsData.add_storage_check_front == true && parseFloat(paramsData.add_storage_front) > parseFloat(paramsData.cB_addStorage_left)
													? 0
													: parseFloat(paramsData.cB_addStorage_left)
										) +
										parseFloat(
											const_var.wallsData["center"].p_b_w == "Close"
												? paramsData.p_w
												: paramsData.add_storage_check_back == true && parseFloat(paramsData.add_storage_back) > parseFloat(paramsData.cB_addStorage_left)
													? 0
													: parseFloat(paramsData.cB_addStorage_left)
										);
								} else {
									fullClosedWidthCalc =
										parseFloat(const_var.wallsData["center"].p_f_w == "Close" ? paramsData.p_w : parseFloat(paramsData.cB_addStorage_right)) +
										parseFloat(const_var.wallsData["center"].p_b_w == "Close" ? paramsData.p_w : parseFloat(paramsData.cB_addStorage_right));
								}
							} else {
								fullClosedLengthCalc = parseFloat(const_var.wallsData["center"].p_l_w == "Close" ? paramsData.p_d : 0) + parseFloat(const_var.wallsData["center"].p_r_w == "Close" ? paramsData.p_d : 0);
								fullClosedWidthCalc = parseFloat(const_var.wallsData["center"].p_f_w == "Close" ? paramsData.p_w : 0) + parseFloat(const_var.wallsData["center"].p_b_w == "Close" ? paramsData.p_w : 0);
							}
							wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc, fullClosedLengthCalc, costObj, false);
						} else {
							if (params.p_b_t == 27 || params.p_b_t == 33) {
								let single_slope_height =
									const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
										? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
										: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12);

								if (paramsData.p_u_c == true) {
									sideCount = parseFloat(const_var.wallsData["center"].closedSideWalls);
									endCount = parseFloat(const_var.wallsData["center"].closedEndWalls);

									if (const_var.wallsData["center"].p_f_w == "Open" && const_var.wallsData["center"].p_b_w == "Open") {
										endPrice = parseFloat(endPrice) + parseFloat(paramsData.p_h * paramsData.p_w * costObj.cost * endCount);
									} else {
										let storageFrontWall = parseFloat(endPrice) + parseFloat(paramsData.p_h * paramsData.p_w * costObj.cost);
										let FWall = calcWallCostUtility("backStorage", "end", paramsData, const_var.wallsData["center"].p_f_w, costObj);
										let BWall = calcWallCostUtility("backStorage", "end", paramsData, const_var.wallsData["center"].p_b_w, costObj);

										endPrice = parseFloat(endPrice) + FWall + BWall + parseFloat(storageFrontWall);
									}
									if (const_var.wallsData["center"].p_l_w == "Open" && const_var.wallsData["center"].p_r_w == "Open") {
										sidePrice = parseFloat(sidePrice) + parseFloat(paramsData.p_u_t * parseFloat(single_slope_height) * costObj.cost);

										sidePrice = parseFloat(sidePrice) + parseFloat(paramsData.p_u_t * paramsData.p_h * costObj.cost);
									} else {
										sidePrice =
											parseFloat(sidePrice) +
											calcWallCostUtility("backStorage", "side", paramsData, const_var.wallsData["center"].p_l_w, costObj, 0, 0, 0, single_slope_height, true) +
											calcWallCostUtility("backStorage", "side", paramsData, const_var.wallsData["center"].p_r_w, costObj);
									}
								} else if (paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
									sideCount = parseFloat(const_var.wallsData["center"].closedSideWalls);
									endCount = parseFloat(const_var.wallsData["center"].closedEndWalls);

									let exactCalculation = 0; // ########## variable to store higher height/ pitch height ##########
									let storageValue = paramsData.cB_addStorage_check_left ? paramsData.cB_addStorage_left : paramsData.cB_addStorage_right;
									if (parseInt(storageValue) > paramsData.p_w / 2) {
										exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * parseFloat(storageValue)));
									} else {
										exactCalculation = parseInt(Math.round(params.p_h - params.p_r_p) + Math.ceil((params.p_r_p / params.p_w) * parseFloat(storageValue)));
									}
									let smWallCount = parseInt(sideCount) - 1;
									if (const_var.wallsData["center"].p_f_w == "Open" && const_var.wallsData["center"].p_b_w == "Open") {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.cB_addStorage_check_right == true ? paramsData.p_h : exactCalculation) * storageValue * costObj.cost * endCount);

										sidePrice = parseFloat(sidePrice) + parseFloat(paramsData.p_d * (paramsData.cB_addStorage_check_right == true ? paramsData.p_h : single_slope_height) * costObj.cost);

										let wallsidePrice =
											paramsData.cB_addStorage_check_right == true
												? calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_l_w, costObj, storageValue, 0, 0, single_slope_height)
												: calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_r_w, costObj, storageValue);

										sidePrice = parseFloat(sidePrice) + parseFloat(wallsidePrice);

										sidePrice = parseFloat(sidePrice) + parseFloat(paramsData.p_d * exactCalculation * costObj.cost);
									} else {
										let LeftWall = calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_l_w, costObj, storageValue, 0, 0, single_slope_height);
										let RightWall = calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_r_w, costObj, storageValue);

										let FrontWall = calcWallCostUtility("sideStorage", "end", paramsData, const_var.wallsData["center"].p_f_w, costObj, storageValue);
										let BackWall = calcWallCostUtility("sideStorage", "end", paramsData, const_var.wallsData["center"].p_b_w, costObj, storageValue);

										let pitchHeightCalc = parseFloat(paramsData.p_d * exactCalculation * costObj.cost);

										sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall) + parseFloat(RightWall) + parseFloat(pitchHeightCalc);
										endPrice = parseFloat(endPrice) + parseFloat(FrontWall) + parseFloat(BackWall);
									}
								} else {
									let endWallCost =
										(const_var.wallsData["center"].p_f_w != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["center"].p_f_w, costObj, "") : 0) +
										(const_var.wallsData["center"].p_b_w != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["center"].p_b_w, costObj) : 0);

									let sideWallCost =
										(const_var.wallsData["center"].p_l_w != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["center"].p_l_w, costObj, "", "", single_slope_height) : 0) +
										(const_var.wallsData["center"].p_r_w != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["center"].p_r_w, costObj) : 0);

									sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData["center"].closedSideWalls);
									endCount = parseFloat(endCount) + parseFloat(const_var.wallsData["center"].closedEndWalls);

									sidePrice = parseFloat(sidePrice) + sideWallCost;
									endPrice = parseFloat(endPrice) + endWallCost;
								}
							} else {
								if (paramsData.p_u_c == true) {
									sideCount = parseFloat(const_var.wallsData["center"].closedSideWalls);
									endCount = parseFloat(const_var.wallsData["center"].closedEndWalls);

									if (const_var.wallsData["center"].p_f_w == "Open" && const_var.wallsData["center"].p_b_w == "Open") {
										if (params.m_s_n == 93) {
											endPrice = parseFloat(endPrice) + parseFloat((paramsData.p_h + 1.5) * paramsData.p_w * costObj.cost * endCount);
										} else {
											endPrice = parseFloat(endPrice) + parseFloat((paramsData.p_h + 1) * paramsData.p_w * costObj.cost * endCount);
										}
									} else {
										let storageFrontWall =
											parseFloat(endPrice) +
											(params.m_s_n == 93 ? parseFloat((paramsData.p_h + 1.5) * paramsData.p_w * costObj.cost) : parseFloat((paramsData.p_h + 1) * paramsData.p_w * costObj.cost));
										let FWall = calcWallCostUtility("backStorage", "end", paramsData, const_var.wallsData["center"].p_f_w, costObj, 0, 0, 0, 0, true, "frontwall");
										let BWall = calcWallCostUtility("backStorage", "end", paramsData, const_var.wallsData["center"].p_b_w, costObj, 0, 0, 0, 0, true, "backwall");
										endPrice = parseFloat(endPrice) + FWall + BWall + parseFloat(storageFrontWall);
									}
									if (const_var.wallsData["center"].p_l_w == "Open" && const_var.wallsData["center"].p_r_w == "Open") {
										sidePrice = parseFloat(sidePrice) + parseFloat(paramsData.p_u_t * paramsData.p_h * costObj.cost * sideCount);
									} else {
										sidePrice =
											parseFloat(sidePrice) +
											calcWallCostUtility("backStorage", "side", paramsData, const_var.wallsData["center"].p_l_w, costObj, 0, 0, 0, 0, true, "leftwall") +
											calcWallCostUtility("backStorage", "side", paramsData, const_var.wallsData["center"].p_r_w, costObj, 0, 0, 0, 0, true, "rightwall");
									}
								} else if (paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
									sideCount = parseFloat(const_var.wallsData["center"].closedSideWalls);

									let exactCalculation = 0; // ########## variable to store higher height/ pitch height ##########
									let storageValue = paramsData.cB_addStorage_check_left ? paramsData.cB_addStorage_left : paramsData.cB_addStorage_right;
									if (parseInt(storageValue) > paramsData.p_w / 2) {
										exactCalculation = parseInt(paramsData.p_h) + parseInt(paramsData.p_r_p);
									} else {
										exactCalculation = parseInt(paramsData.p_h + Math.ceil((paramsData.p_r_p / (paramsData.p_w / 2)) * storageValue));
									}
									let smWallCount = parseInt(sideCount) - 1;

									if (const_var.wallsData["center"].p_f_w == "Open" && const_var.wallsData["center"].p_b_w == "Open") {
										if (params.m_s_n == 93) {
											endPrice = parseFloat(endPrice) + parseFloat((paramsData.p_h + 1.5) * storageValue * costObj.cost * endCount);
										} else {
											endPrice = parseFloat(endPrice) + parseFloat((paramsData.p_h + 1) * storageValue * costObj.cost * endCount);
										}
										sidePrice = parseFloat(sidePrice) + parseFloat(paramsData.p_d * paramsData.p_h * costObj.cost);

										let wallsidePrice =
											paramsData.cB_addStorage_check_right == true
												? calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_l_w, costObj, storageValue)
												: calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_r_w, costObj, storageValue);

										sidePrice = parseFloat(sidePrice) + parseFloat(wallsidePrice);

										sidePrice = parseFloat(sidePrice) + parseFloat(paramsData.p_d * exactCalculation * costObj.cost);
									} else {
										let LeftWall = calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_l_w, costObj, storageValue);
										let RightWall = calcWallCostUtility("sideStorage", "side", paramsData, const_var.wallsData["center"].p_r_w, costObj, storageValue);

										let FrontWall = calcWallCostUtility("sideStorage", "end", paramsData, const_var.wallsData["center"].p_f_w, costObj, storageValue);
										let BackWall = calcWallCostUtility("sideStorage", "end", paramsData, const_var.wallsData["center"].p_b_w, costObj, storageValue);

										let pitchHeightCalc = parseFloat(paramsData.p_d * exactCalculation * costObj.cost);

										sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall) + parseFloat(RightWall) + parseFloat(pitchHeightCalc);
										endPrice = parseFloat(endPrice) + parseFloat(FrontWall) + parseFloat(BackWall);
									}
								} else {
									let endWallCost =
										parseFloat(const_var.wallsData["center"].p_f_w != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["center"].p_f_w, costObj, "", 0, 0, true, "frontwall") : 0) +
										parseFloat(const_var.wallsData["center"].p_b_w != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["center"].p_b_w, costObj, "", 0, 0, true, "backwall") : 0);

									let sideWallCost =
										(const_var.wallsData["center"].p_l_w != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["center"].p_l_w, costObj, "", 0, 0, true, "leftwall") : 0) +
										(const_var.wallsData["center"].p_r_w != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["center"].p_r_w, costObj, "", 0, 0, true, "rightwall") : 0);

									sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData["center"].closedSideWalls);
									endCount = parseFloat(endCount) + parseFloat(const_var.wallsData["center"].closedEndWalls);

									sidePrice = parseFloat(sidePrice) + sideWallCost;
									endPrice = parseFloat(endPrice) + endWallCost;
								}
							}
						}
						roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.p_w, paramsData.p_d, costObj, paramsData);
					}
					if (Object.keys(const_var.wallsData["frontLean"]).length > 0 && paramsData.add_front_lean == true) {
						let leanToLength = parseInt(paramsData.leanF_p_d);
						let wrapIncludedCount = 0;
						if (paramsData.add_right_front_lean_porch == true) {
							wrapIncludedCount = 1;
						}
						if (paramsData.add_left_front_lean_porch == true) {
							wrapIncludedCount = parseInt(wrapIncludedCount) + 1;
						}

						if (paramsData.add_right_front_lean_porch == true) {
							leanToLength = parseInt(leanToLength) + parseInt(paramsData.leanR_p_w);
						}
						if (paramsData.add_left_front_lean_porch == true) {
							leanToLength = parseInt(leanToLength) + parseInt(paramsData.lean_p_w);
						}
						let sideLeanCount = parseFloat(const_var.wallsData["frontLean"].closedSideWalls);
						if (calcfor == "wainscot") {
							let fullClosedWidthCalc = 0;
							let fullClosedLengthCalc = 0;
							if (paramsData.add_storage_check_front == true) {
								fullClosedLengthCalc =
									(const_var.wallsData["frontLean"].p_b_c_b_f_l == "Close" ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage_front)) +
									(const_var.wallsData["center"].p_f_w == "Close"
										? 0
										: paramsData.cB_addStorage_check_left == true && parseFloat(paramsData.cB_addStorage_left) >= parseFloat(paramsData.add_storage_front)
											? 0
											: parseFloat(paramsData.add_storage_front));
								fullClosedWidthCalc =
									parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_f == "Close" ? paramsData.leanF_p_w : 0) +
									parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_b == "Close" ? paramsData.leanF_p_w : 0) +
									parseFloat(paramsData.leanF_p_w);
							} else {
								fullClosedLengthCalc = parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_l == "Close" ? leanToLength : 0);
								fullClosedWidthCalc =
									parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_f == "Close" ? paramsData.leanF_p_w : 0) +
									parseFloat(const_var.wallsData["frontLean"].p_b_c_b_f_b == "Close" ? paramsData.leanF_p_w : 0);
							}
							wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc, fullClosedLengthCalc, costObj, true);
						} else {
							if (const_var.wallsData["frontLean"].closedSideWalls != 0) {
								if (paramsData.add_storage_check_front == true) {
									if (const_var.wallsData["center"].p_f_w != "Open") {
										sideLeanCount = sideLeanCount - 1;
									}
									let LeftWall = calcWallCostUtility(
										"frontLeanStorage",
										"side",
										paramsData,
										const_var.wallsData["frontLean"].p_b_c_b_f_l,
										costObj,
										paramsData.add_storage_front,
										leanToLength,
										sideLeanCount
									);

									sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
								} else {
									sidePrice =
										parseFloat(sidePrice) +
										(const_var.wallsData["frontLean"].p_b_c_b_f_l != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["frontLean"].p_b_c_b_f_l, costObj, "front", leanToLength) : 0);
								}
								// }
							}
							if (const_var.wallsData["frontLean"].closedEndWalls != 0) {
								if (paramsData.add_storage_check_front == true) {
									if (params.m_s_n == 93) {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.leanF_p_h + 1.5) * paramsData.leanF_p_w * costObj.cost);
									} else {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.leanF_p_h + 1) * paramsData.leanF_p_w * costObj.cost);
									}
								}
								endPrice =
									parseFloat(endPrice) +
									(const_var.wallsData["frontLean"].p_b_c_b_f_f != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["frontLean"].p_b_c_b_f_f, costObj, "front") : 0) +
									(const_var.wallsData["frontLean"].p_b_c_b_f_b != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["frontLean"].p_b_c_b_f_b, costObj, "front") : 0);
							}
						}
						roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanF_p_w, parseInt(leanToLength), costObj, paramsData, true, wrapIncludedCount);
					}
					if (Object.keys(const_var.wallsData["backLean"]).length > 0 && paramsData.add_back_lean == true) {
						let leanToLength = parseInt(paramsData.leanB_p_d);
						let wrapIncludedCount = 0;
						if (paramsData.add_right_back_lean_porch == true) {
							wrapIncludedCount = 1;
						}
						if (paramsData.add_left_back_lean_porch == true) {
							wrapIncludedCount = parseInt(wrapIncludedCount) + 1;
						}

						if (paramsData.add_right_back_lean_porch == true) {
							leanToLength = parseInt(leanToLength) + parseInt(paramsData.leanR_p_w);
						}
						if (paramsData.add_left_back_lean_porch == true) {
							leanToLength = parseInt(leanToLength) + parseInt(paramsData.lean_p_w);
						}
						let sideLeanCount = parseFloat(const_var.wallsData["backLean"].closedSideWalls);

						if (calcfor == "wainscot") {
							let fullClosedWidthCalc = 0;
							let fullClosedLengthCalc = 0;
							if (paramsData.add_storage_check_back == true) {
								fullClosedLengthCalc =
									(const_var.wallsData["backLean"].p_b_c_b_b_l == "Close" ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage_back)) +
									(const_var.wallsData["center"].p_b_w == "Close"
										? 0
										: paramsData.cB_addStorage_check_left == true && parseFloat(paramsData.cB_addStorage_left) >= parseFloat(paramsData.add_storage_back)
											? 0
											: parseFloat(paramsData.add_storage_back));
								fullClosedWidthCalc =
									parseFloat(const_var.wallsData["backLean"].p_b_c_b_b_f == "Close" ? paramsData.leanB_p_w : 0) +
									parseFloat(const_var.wallsData["backLean"].p_b_c_b_b_b == "Close" ? paramsData.leanB_p_w : 0) +
									parseFloat(paramsData.leanB_p_w);
							} else {
								fullClosedLengthCalc = parseFloat(const_var.wallsData["backLean"].p_b_c_b_b_l == "Close" ? leanToLength : 0);
								fullClosedWidthCalc =
									parseFloat(const_var.wallsData["backLean"].p_b_c_b_b_f == "Close" ? paramsData.leanB_p_w : 0) +
									parseFloat(const_var.wallsData["backLean"].p_b_c_b_b_b == "Close" ? paramsData.leanB_p_w : 0);
							}
							wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc, fullClosedLengthCalc, costObj, true);
						} else {
							if (const_var.wallsData["backLean"].closedSideWalls != 0) {
								if (const_var.wallsData["center"].p_b_w != "Open" || paramsData.p_u_c == true) {
									sideLeanCount = sideLeanCount - 1;
								}
								if (paramsData.add_storage_check_back == true) {
									let LeftWall = calcWallCostUtility(
										"backLeanStorage",
										"side",
										paramsData,
										const_var.wallsData["backLean"].p_b_c_b_b_l,
										costObj,
										paramsData.add_storage_back,
										leanToLength,
										sideLeanCount
									);

									sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
								} else {
									sidePrice =
										parseFloat(sidePrice) +
										(const_var.wallsData["backLean"].p_b_c_b_b_l != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["backLean"].p_b_c_b_b_l, costObj, "back", leanToLength) : 0);
								}
							}
							if (const_var.wallsData["backLean"].closedEndWalls != 0) {
								if (paramsData.add_storage_check_back == true) {
									if (params.m_s_n == 93) {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.leanB_p_h + 1.5) * paramsData.leanB_p_w * costObj.cost);
									} else {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.leanB_p_h + 1) * paramsData.leanB_p_w * costObj.cost);
									}
								}
								endPrice =
									parseFloat(endPrice) +
									(const_var.wallsData["backLean"].p_b_c_b_b_f != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["backLean"].p_b_c_b_b_f, costObj, "back") : 0) +
									(const_var.wallsData["backLean"].p_b_c_b_b_b != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["backLean"].p_b_c_b_b_b, costObj, "back") : 0);
							}
						}
						roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanB_p_w, parseInt(leanToLength), costObj, paramsData, true, wrapIncludedCount);
					}
					if (Object.keys(const_var.wallsData["leftLean"]).length > 0 && paramsData.add_left_lean == true) {
						let leanToLength = paramsData.lean_p_d;
						let wrapIncludedCount = 0;
						if (paramsData.add_left_front_lean_porch == true) {
							wrapIncludedCount = 1;
						}
						if (paramsData.add_left_back_lean_porch == true) {
							wrapIncludedCount = parseInt(wrapIncludedCount) + 1;
						}
						if (paramsData.add_left_front_lean_porch == true) {
							leanToLength = leanToLength + parseInt(paramsData.leanF_p_w);
						}
						if (paramsData.add_left_back_lean_porch == true) {
							leanToLength = leanToLength + parseInt(paramsData.leanB_p_w);
						}
						let sideLeanCount = parseFloat(const_var.wallsData["leftLean"].closedSideWalls);

						if (calcfor == "wainscot") {
							let fullClosedWidthCalc = 0;
							let fullClosedLengthCalc = 0;
							if (paramsData.add_storage_check == true) {
								fullClosedLengthCalc =
									(const_var.wallsData["leftLean"].p_b_c_b_l == "Close" ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage)) +
									(const_var.wallsData["center"].p_l_w == "Close"
										? 0
										: paramsData.p_u_c == true && parseInt(paramsData.p_u_t) >= parseInt(paramsData.add_storage)
											? 0
											: paramsData.cB_addStorage_check_left
												? parseFloat(paramsData.cB_addStorage_left)
												: parseFloat(paramsData.add_storage));
								fullClosedWidthCalc =
									(const_var.wallsData["leftLean"].p_b_c_b_l_f == "Close" ? paramsData.lean_p_w : 0) +
									(const_var.wallsData["leftLean"].p_b_c_b_l_b == "Close" ? paramsData.lean_p_w : 0) +
									parseFloat(paramsData.lean_p_w);
							} else {
								fullClosedLengthCalc = const_var.wallsData["leftLean"].p_b_c_b_l == "Close" ? leanToLength : 0;
								fullClosedWidthCalc =
									(const_var.wallsData["leftLean"].p_b_c_b_l_f == "Close" ? paramsData.lean_p_w : 0) + (const_var.wallsData["leftLean"].p_b_c_b_l_b == "Close" ? paramsData.lean_p_w : 0);
							}
							wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc, fullClosedLengthCalc, costObj, true);
						} else {
							if (const_var.wallsData["leftLean"].closedSideWalls != 0) {
								if (const_var.wallsData["center"].p_l_w != "Open" || paramsData.p_u_c == true || paramsData.cB_addStorage_check_left == true) {
									sideLeanCount = sideLeanCount - 1;
								}
								if (paramsData.add_storage_check == true) {
									let LeftWall = calcWallCostUtility("leftLeanStorage", "side", paramsData, const_var.wallsData["leftLean"].p_b_c_b_l, costObj, paramsData.add_storage, leanToLength, sideLeanCount);
									sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
								} else {
									sidePrice =
										parseFloat(sidePrice) +
										(const_var.wallsData["leftLean"].p_b_c_b_l != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["leftLean"].p_b_c_b_l, costObj, "left", leanToLength) : 0);
								}
							}
							if (const_var.wallsData["leftLean"].closedEndWalls != 0) {
								if (paramsData.add_storage_check == true) {
									if (params.m_s_n == 93) {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.lean_p_h + 1.5) * paramsData.lean_p_w * costObj.cost);
									} else {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.lean_p_h + 1) * paramsData.lean_p_w * costObj.cost);
									}
								}

								endPrice =
									parseFloat(endPrice) +
									(const_var.wallsData["leftLean"].p_b_c_b_l_f != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["leftLean"].p_b_c_b_l_f, costObj, "left") : 0) +
									(const_var.wallsData["leftLean"].p_b_c_b_l_b != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["leftLean"].p_b_c_b_l_b, costObj, "left") : 0);
							}
						}
						roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.lean_p_w, parseInt(leanToLength), costObj, paramsData, true, wrapIncludedCount);
					}
					if (Object.keys(const_var.wallsData["rightLean"]).length > 0 && paramsData.add_right_lean == true) {
						let leanToLength = parseInt(paramsData.leanR_p_d);
						let wrapIncludedCount = 0;
						if (paramsData.add_right_front_lean_porch == true) {
							wrapIncludedCount = 1;
						}
						if (paramsData.add_right_back_lean_porch == true) {
							wrapIncludedCount = parseInt(wrapIncludedCount) + 1;
						}
						if (paramsData.add_right_front_lean_porch == true) {
							leanToLength = leanToLength + parseInt(paramsData.leanF_p_w);
						}
						if (paramsData.add_right_back_lean_porch == true) {
							leanToLength = leanToLength + parseInt(paramsData.leanB_p_w);
						}
						let sideLeanCount = parseFloat(const_var.wallsData["rightLean"].closedSideWalls);

						if (calcfor == "wainscot") {
							let fullClosedWidthCalc = 0;
							let fullClosedLengthCalc = 0;
							if (paramsData.add_storage_check_right == true) {
								fullClosedLengthCalc =
									(const_var.wallsData["rightLean"].p_b_c_b_r == "Close" ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage_right)) +
									parseFloat(
										const_var.wallsData["center"].p_r_w == "Close"
											? 0
											: paramsData.p_u_c == true && parseFloat(paramsData.p_u_t) >= parseFloat(paramsData.add_storage_right)
												? 0
												: paramsData.cB_addStorage_check_right == true
													? parseFloat(paramsData.cB_addStorage_right)
													: parseFloat(paramsData.add_storage_right)
									);
								fullClosedWidthCalc =
									parseFloat(const_var.wallsData["rightLean"].p_b_c_b_r_f == "Close" ? paramsData.leanR_p_w : 0) +
									parseFloat(const_var.wallsData["rightLean"].p_b_c_b_r_b == "Close" ? paramsData.leanR_p_w : 0) +
									parseFloat(paramsData.leanR_p_w);
							} else {
								fullClosedLengthCalc = parseFloat(const_var.wallsData["rightLean"].p_b_c_b_r == "Close" ? leanToLength : 0);
								fullClosedWidthCalc =
									parseFloat(const_var.wallsData["rightLean"].p_b_c_b_r_f == "Close" ? paramsData.leanR_p_w : 0) +
									parseFloat(const_var.wallsData["rightLean"].p_b_c_b_r_b == "Close" ? paramsData.leanR_p_w : 0);
							}
							wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc, fullClosedLengthCalc, costObj, true);
						} else {
							if (const_var.wallsData["rightLean"].closedSideWalls != 0) {
								if (const_var.wallsData["center"].p_r_w != "Open" || paramsData.p_u_c == true || paramsData.cB_addStorage_check_right == true) {
									sideLeanCount = sideLeanCount - 1;
								}
								if (paramsData.add_storage_check_right == true) {
									let LeftWall = calcWallCostUtility(
										"rightLeanStorage",
										"side",
										paramsData,
										const_var.wallsData["rightLean"].p_b_c_b_r,
										costObj,
										paramsData.add_storage_right,
										leanToLength,
										sideLeanCount
									);

									sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
								} else {
									sidePrice =
										parseFloat(sidePrice) +
										(const_var.wallsData["rightLean"].p_b_c_b_r != "Open" ? calcWallCost(paramsData, "side", const_var.wallsData["rightLean"].p_b_c_b_r, costObj, "right", leanToLength) : 0);
								}
							}
							if (const_var.wallsData["rightLean"].closedEndWalls != 0) {
								if (paramsData.add_storage_check_right == true) {
									if (params.m_s_n == 93) {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.leanR_p_h + 1.5) * paramsData.leanR_p_w * costObj.cost);
									} else {
										endPrice = parseFloat(endPrice) + parseFloat((paramsData.leanR_p_h + 1) * paramsData.leanR_p_w * costObj.cost);
									}
								}
								endPrice =
									parseFloat(endPrice) +
									(const_var.wallsData["rightLean"].p_b_c_b_r_f != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["rightLean"].p_b_c_b_r_f, costObj, "right") : 0) +
									(const_var.wallsData["rightLean"].p_b_c_b_r_b != "Open" ? calcWallCost(paramsData, "end", const_var.wallsData["rightLean"].p_b_c_b_r_b, costObj, "right") : 0);
							}
						}
						roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanR_p_w, parseInt(leanToLength), costObj, paramsData, true, wrapIncludedCount);
					}
				}

				if (calcfor == "roof") {
					finalCost = parseFloat(roofPrice);
				} else if (calcfor == "wall") {
					finalCost = parseFloat(sidePrice) + parseFloat(endPrice);
				} else if (calcfor == "wainscot") {
					finalCost = parseFloat(wainscotPrice);
				} else {
					finalCost = parseFloat(roofPrice) + parseFloat(sidePrice) + parseFloat(endPrice);
				}
			} else {
				finalCost = costObj.cost;
			}
		}
	}
	if (const_var.isLNTBuildingIsCustom === true) {
		return 0;
	} else {
		return convertToTwoDecimalNumber(finalCost);
	}
}
